import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { VIEW_ONLY } = PERMISSIONS_OPTIONS_VALUE;

export const APP_STORE_PERMISSIONS = {
  [VIEW_ONLY]: {
    DIM_INSTALL_BUTTON: true,
    DIM_MANAGE_BUTTON: true
  }
};
